export const guestSub = "88a107d1-bbfe-45fa-a242-fb43ce6d28d1";
export const guestUsername = "guest@clickndrone.com";
export const guestPassword = "guest@clickndrone.com";